<template>
  <b-card :class="'order-1 border card overflow-hidden rounded shadow mt-4 mt-sm-0 mt-md-4'" no-body>
    <b-card-header>
      Offer Finance
    </b-card-header>
    <b-card-body>
      <div class="p-2 p-xxl-4">
        <p>{{ lead.enquiry.title }} {{ lead.enquiry.surname }} will receive an email with details to apply for finance</p>
        <div v-b-tooltip="tooltip" class="d-flex justify-content-center">
          <b-button id="financeOfferButton" :disabled="disableFinance" variant="primary" @click="offerFinance">
            Offer Finance
          </b-button>
        </div>
        <p class="text-center mt-1 mb-0">
          <small><router-link :to="{name:'offer-finance'}">Find out more</router-link></small>
        </p>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import notification from "@/imports/mixins/notification";
const MS_PER_DAY = 1000 * 3600 * 24;

export default {
  mixins: [notification],
  props: {
    lead: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      hasOfferedFinance: false,
    }
  },
  computed: {
    purchaseDate() {
      let purchasedDate = null;
      if (this.lead.auto_accepted) {
        purchasedDate = this.lead.first_request;
      } else {
        purchasedDate = this.lead.accepted_date;
      }

      return new Date(purchasedDate);
    },
    daysSincePurchase() {
      return (Date.now() - this.purchaseDate.getTime()) / MS_PER_DAY;
    },
    timeExpired() {
      return this.daysSincePurchase > 14;
    },
    disableFinance() {
      return this.timeExpired || this.lead.enquiry.finance_offer !== null || this.hasOfferedFinance;
    },
    tooltip() {
      if (this.timeExpired) {
        return 'Finance not available for this lead';
      } else if (this.lead.enquiry.finance_offer !== null) {
        return 'This lead has already been sent a finance introduction';
      }

      return '';
    },
  },
  methods: {
    async offerFinance() {
      let toastMessage = null;
      let toastType = null;
      this.hasOfferedFinance = true;

      try {
        await this.$api.leads.offerFinance(this.lead.code);
        toastMessage = `Finance introduction sent to ${this.lead.enquiry.title} ${this.lead.enquiry.surname}`;
        toastType = 'success';
      } catch(e) {
        toastMessage = 'Sorry, there was an error. The finance introduction has not been sent. Please refresh the page and try again.';
        toastType = 'error';
        this.hasOfferedFinance = false;
      }

      this.notify(
        this.$bvToast,
        toastMessage,
        null,
        toastType
      );
    },
  }
}
</script>

<style scoped lang="scss">
.card-body,
.btn {
  font-size: $font-size-14;
}
</style>
